module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolly Erickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Distinguished historian Carolly Erickson is the author of "), _c('I', [_vm._v("The First Elizabeth")]), _c('I', [_vm._v(",")]), _c('I', [_vm._v("Great Catherine")]), _c('I', [_vm._v(",")]), _c('I', [_vm._v("Alexandra,")]), _vm._v(" and a dozen other prize-winning biographies. She lives in Hawaii.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FKC7OO/OEBPS/images/9780312316433_cvi.png?1726444398178",
      "alt": "This image is the cover for the book Royal Panoply"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Royal Panoply\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From medieval conqueror to Renaissance autocrat to Victorian Empress to modern melodrama, "), _c('i', [_vm._v("Royal Panoply")]), _vm._v(" is the story of some of the most fascinating people in world history."), _c('br'), _c('br'), _vm._v("With her trademark blend of probing scholarship, lively prose, and psychological insight, Carolly Erickson focuses on each monarch's entire life---from the puny, socially awkward Charles I, to the choleric, violent William the Conqueror, to the well-meaning, deeply affectionate Queen Anne, who was so heavy she had to be carried to her coronation. "), _c('i', [_vm._v("Royal Panoply")]), _vm._v(" recaptures the event-filled, often dangerous, always engaging lives of England's kings and queens, set against the backdrop of a thousand years of Britain's past.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0